export const EmdenPort = {
  name: "EMDEN",
  formattedName: "Emden Port",
};

export const InoperativePorts = ["Veracruz"];
